define(["require", "exports", "tslib", "./ServiceConfig", "../bootstrap/BootstrapManager", "../bootstrap/BootstrapClassManager", "./ServiceStatus"], function (require, exports, tslib_1, ServiceConfig_1, BootstrapManager_1, BootstrapClassManager_1, ServiceStatus_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServiceAdapter = void 0;
    ServiceConfig_1 = (0, tslib_1.__importDefault)(ServiceConfig_1);
    var ServiceAdapter = (function () {
        function ServiceAdapter(channelFlag) {
            this.tokenSource = 'test';
            this.serverFlag = '';
            this.parentFlag = '';
            this.cookieObj = {};
            this.csrfValue = '';
            this.channelFlag = channelFlag;
            this.status = new ServiceStatus_1.ServiceStatus();
            this.updateDomain();
            this.updateLogs();
        }
        ServiceAdapter.prototype.updateLogs = function () {
            if (!this.logsMgr) {
                this.logsMgr = BootstrapClassManager_1.BootStrapClassManager.getInstance().getLogsManager();
            }
        };
        ServiceAdapter.prototype.getConfig = function () {
            if (!this.tempConfig) {
                this.tempConfig = BootstrapManager_1.bootStrapManager.getConfig();
            }
            return this.tempConfig;
        };
        ServiceAdapter.prototype.updateDomain = function () {
            this.options = {
                baseUrl: '',
                isLocalHost: false,
                channel: this.channelFlag
            };
            this.getConfig();
            if (this.tempConfig) {
                var channel = this.tempConfig.channel;
                var channelData = channel[this.options.channel];
                if (channelData) {
                    this.options.baseUrl = channelData.url;
                }
            }
        };
        ServiceAdapter.prototype.updateConfig = function (url) {
            if (this.options.isLocalHost) {
                return url;
            }
            var baseUrl = this.channelFlag || '';
            var resultUrl = "".concat(baseUrl).concat(url);
            return resultUrl;
        };
        ServiceAdapter.prototype.getToken = function () {
            return this.tokenSource;
        };
        ServiceAdapter.prototype.getUUID = function () {
            var s = [];
            var hexDigits = '0123456789abcdef!@#$%^&*()_+-';
            var hashLength = 36;
            var hashHex = 0x10;
            var pos14 = 14;
            var pos19 = 19;
            var pos8 = 8;
            var pos13 = 13;
            var pos18 = 18;
            var pos23 = 23;
            for (var i = 0; i < hashLength; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * hashHex), 1);
            }
            s[pos14] = '4';
            s[pos19] = hexDigits.substr((s[pos19] & 0x3) | 0x8, 1);
            s[pos8] = s[pos13] = s[pos18] = s[pos23] = '-';
            var uuid = s.join('');
            return uuid;
        };
        ServiceAdapter.prototype.getCSRF = function () {
            var cookieValue = document.cookie || '';
            var reg = /csrftoken=([\w]+)[;]?/g;
            var regValue = reg.exec(cookieValue);
            var regPathValue = '';
            if (regValue && regValue.length > 0) {
                regPathValue = regValue[1];
            }
            return regPathValue;
        };
        Object.defineProperty(ServiceAdapter.prototype, "apiService", {
            get: function () {
                var _this = this;
                if (!this.apiServiceInstance) {
                    this.apiServiceInstance = ServiceConfig_1.default.getAxios();
                    this.tempConfig = this.getConfig();
                    this.status.updateConfig(this.tempConfig);
                    this.apiServiceInstance.interceptors.request.use(function (request) {
                        _this.status.addScene(request);
                        _this.status.addLanguage(request);
                        _this.status.showLoading(request);
                        return request;
                    }, function (error) {
                        _this.status.hideLoading();
                        return Promise.reject(error);
                    });
                    this.apiServiceInstance.interceptors.response.use(function (response) {
                        if (_this.logsMgr) {
                            _this.logsMgr.interceptLogs(response);
                        }
                        _this.status.hideLoading();
                        _this.status.handleLogicalTips(response);
                        return response;
                    }, function (error) {
                        _this.status.hideLoading();
                        if (_this.logsMgr) {
                            _this.logsMgr.addNetworkLogs(error);
                        }
                        _this.status.handleErrors(error);
                        return Promise.reject(error.response || {});
                    });
                }
                return this.apiServiceInstance;
            },
            enumerable: false,
            configurable: true
        });
        return ServiceAdapter;
    }());
    exports.ServiceAdapter = ServiceAdapter;
});
//# sourceMappingURL=ServiceAdapter.js.map